<mat-form-field class="w-full">
  <mat-select
    value="{{ this.paymentType }}"
    (valueChange)="toggleSplitPayment($event)"
    required>
    <mat-select-trigger>
      <div class="flex items-center">
        <mat-icon>{{
          paymentType === 'SPLIT_PAYMENT' ? 'shopping_cart' : 'paid'
        }}</mat-icon>
        <span class="leading-[normal] ml-1">{{
          this.labels[this.paymentType] | translate
        }}</span>
      </div>
    </mat-select-trigger>
    <mat-option [value]="option.value" *ngFor="let option of this.options">
      <span>{{ option.label | translate }}</span>
    </mat-option>
  </mat-select>
  <mat-hint
    *ngIf="this.paymentType === 'SPLIT_PAYMENT'"
    class="text-sm -ml-3 mt-1">
    {{ 'paymentSplit:selectHint' | translate }}
  </mat-hint>
</mat-form-field>
